export default __webpack_public_path__ + "static/media/juego_edocuenta_instrucciones.a9f6f40a.png";